<template>
    <div>
        <v-label v-if="label">{{ label }}</v-label><br />
        <v-menu v-if="value" open-on-hover offset-y>
            <template v-slot:activator="{on, attrs}">
                <v-chip class="mt-2" v-on="on" v-bind="attrs" color="primary">{{ items.filter(item => item.id == value)?.[0]?.name }}</v-chip>
            </template>
            <eod-card>
                <v-card-text>
                <v-chip-group :value="value" @change="val => $emit('input', val)" column active-class="primary white--text">
                    <v-chip style="border: 1px solid #eeeeee;background-color: transparent;" v-for="item in items" :key="item.id" :value="item.id">{{ item.name }}</v-chip>
                </v-chip-group>
                </v-card-text>
            </eod-card>
        </v-menu>
        <v-chip-group v-else :value="value" @change="val => $emit('input', val)" column active-class="primary white--text">
                <v-chip style="border: 1px solid #eeeeee;background-color: transparent;" v-for="item in items" :key="item.id" :value="item.id">{{ item.name }}</v-chip>
            </v-chip-group>
    </div>
</template>
<script>
export default {
    name: 'eod-list-label-selector',
    props:{
        value: String,
        listId: String,
        label: String,
    },
    data: () => ({
        items: []
    }),
    created(){
        this.$eod.get('listItems', ['id','name','description', 'threshold', 'isActive'], {
            orderBy:{
                column: 'threshold',
                type: 'ASC'
            },
            where:[
                {
                    column: 'listId',
                    operator: '=',
                    value: this.listId
                },
                {
                    column: 'isActive',
                    operator: '=',
                    value: '1'
                }
            ]
        }).then(result => {
            this.items = result.data.data.listItems.edges;
        });
    }
}
</script>